import { FunctionComponent, useEffect, useState } from "react";
import { useAppSelector } from "./store/hooks";
import { UserProfile, getLeaderboard, getRankLabel } from "./services/FirebaseUsers";

type LeaderboardPanelProps = {
  onClose: () => void;
};

const LeaderboardPanel: FunctionComponent<LeaderboardPanelProps> = ({
  onClose,
}) => {
  const myProfile = useAppSelector((state) => state.user.profile);
  const [entries, setEntries] = useState<UserProfile[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getLeaderboard(50)
      .then((data) => {
        setEntries(data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  return (
    <div className="Leaderboard-overlay" onClick={onClose}>
      <div className="Leaderboard-modal" onClick={(e) => e.stopPropagation()}>
        <div className="Leaderboard-header">
          <h2 className="Leaderboard-title">Таблица лидеров</h2>
          <button className="Leaderboard-close" onClick={onClose}>&#x2715;</button>
        </div>

        {isLoading ? (
          <div className="Lobby-loading">
            <div className="Lobby-spinner" />
            <span>Загрузка...</span>
          </div>
        ) : entries.length === 0 ? (
          <div className="Lobby-empty">
            <p>Пока никого нет</p>
            <span>Сыграйте первую игру!</span>
          </div>
        ) : (
          <div className="Leaderboard-list">
            <div className="Leaderboard-list-header">
              <span>#</span>
              <span>Игрок</span>
              <span>Рейтинг</span>
              <span>Побед</span>
              <span>%</span>
            </div>
            {entries.map((entry, idx) => {
              const isMe = entry.uid === myProfile?.uid;
              const winRate =
                entry.gamesPlayed > 0
                  ? ((entry.wins / entry.gamesPlayed) * 100).toFixed(0)
                  : "—";
              return (
                <div
                  key={entry.uid}
                  className={`Leaderboard-row ${isMe ? "is-me" : ""} rank-${idx + 1}`}
                >
                  <span className="Leaderboard-rank">
                    {idx + 1 <= 3 ? (
                      <span className={`Leaderboard-medal medal-${idx + 1}`}>
                        {idx + 1}
                      </span>
                    ) : (
                      idx + 1
                    )}
                  </span>
                  <div className="Leaderboard-player">
                    <span className="Leaderboard-nickname">{entry.nickname}</span>
                    <span className="Leaderboard-rank-label">
                      {getRankLabel(entry.rating)}
                    </span>
                  </div>
                  <span className="Leaderboard-rating">{entry.rating}</span>
                  <span className="Leaderboard-wins">{entry.wins}</span>
                  <span className="Leaderboard-winrate">{winRate}%</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaderboardPanel;
